"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DriverMessageOutput = void 0;
const class_validator_1 = require("class-validator");
class DriverMessageOutput {
}
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverMessageOutput.prototype, "id", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverMessageOutput.prototype, "key", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverMessageOutput.prototype, "createdAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverMessageOutput.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    __metadata("design:type", String)
], DriverMessageOutput.prototype, "body", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsEnum)([
        'TRIP_UPDATE',
        'TRIP_AFFECTION',
        'TRIP_DISAFFECTION',
        'OPEN_HOME',
        'SHOW_MESSAGE',
        'OPEN_DOCUMENT',
        'DRIVER_CALL_CREATED',
        'DRIVER_CALL_FINISHED',
        'MARKETPLACE_REMOVE',
        'OPEN_INVOICE_RESUME',
        'BREAK_TIME_START',
        'BREAK_TIME_END',
        'DEDICATED_PERIOD_STARTED',
        'DEDICATED_PERIOD_ENDED',
        'DISCONNECTED',
        'REFUSED_DOC',
        'EXPIRED_DOC',
        'PACKAGE_INFO',
        'PACKAGE_INFO_CREATED',
    ]),
    __metadata("design:type", String)
], DriverMessageOutput.prototype, "action", void 0);
__decorate([
    (0, class_validator_1.IsBoolean)(),
    __metadata("design:type", Boolean)
], DriverMessageOutput.prototype, "read", void 0);
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    __metadata("design:type", Number)
], DriverMessageOutput.prototype, "readAt", void 0);
exports.DriverMessageOutput = DriverMessageOutput;
